module.exports = __webpack_public_path__ + "img/project-1.3d483064.jpg";